import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

const Overview = lazy(() => import('./pages/overview/overview.page'));

export const IncidentResponseRoutes = () => {
  return (
    <Routes>
      <Route index element={<Overview />} />
    </Routes>
  );
};
